import { Question, MultiChoiceQuestion } from '@policygenius/dif-ts-types';

const isBooleanMultiChoiceQuestion = (node: Question): node is MultiChoiceQuestion =>
  node.questionType === 'MULTI_CHOICE' &&
  node.dataPoint.dataType === 'text_list' &&
  node.dataPoint.subtype === 'boolean_dpid_urn';

export default isBooleanMultiChoiceQuestion;
